export default __webpack_public_path__ + "static/media/slider3.74f42697.jpg";